﻿<script>
	import { Router, Route, navigate } from "svelte-routing";

	import { model } from "../stores";
	import { projectSettings } from "../config";

	import RegistrationLandingPage from "./Registration/LandingPage.svelte";
	import PersonalDetails from "./Registration/PersonalDetails.svelte";
	import Details from "./Registration/Details.svelte";
	import Confirmation from "./Registration/Confirmation.svelte";
	import Review from "./Registration/Review.svelte";
	import ThankYou from "./Registration/ThankYou.svelte";

	import FileUploadLandingPage from "./FileUpload/LandingPage.svelte";
	import Files from "./FileUpload/Files.svelte";
	import FileUploadThankYou from "./FileUpload/ThankYou.svelte";

	import Error from "./Error.svelte";
	import NavTracker from "../components/NavTracker.svelte";

	export let url = "";
	export let basepath = "/";

	let pageList = null;

	const registrationPageList = [
		{
			pageIndex: 0,
			pageTitle: `${projectSettings.classActionName}`,
			title: "Landing Page",
			showInTracker: false,
			lastVisitedPage: "Landing Page",
			nextPage: "Registration/PersonalDetails"
		},
		{
			pageIndex: 1,
			title: "Personal Details",
			showInTracker: true,
			pageTitle: `${projectSettings.classActionName} - Personal Details`,
			nextPage: "Registration/Details",
			previousPage: "Registration",
			persistUrl: "api/project",
			lastVisitedPage: "Personal Details"
		},
		{
			pageIndex: 2,
			title: "Action Specific",
			showInTracker: true,
			pageTitle: `${projectSettings.classActionName} - Action Specific`,
			nextPage: "Registration/Confirmation",
			previousPage: "Registration/PersonalDetails",
			persistUrl: "api/project",
			lastVisitedPage: "Action Specific"
		},
		{
			pageIndex: 3,
			title: "Confirmation",
			showInTracker: true,
			pageTitle: `${projectSettings.classActionName} - Confirmation`,
			nextPage: "Registration/ThankYou",
			nextPageLabel: "Submit",
			previousPage: "Registration/Details",
			persistUrl: "api/registration",
			lastVisitedPage: "Confirmation"
		},
		{
			pageIndex: 4,
			title: "Thank You",
			showInTracker: true,
			pageTitle: `${projectSettings.classActionName} - Thank You`
		},
		{
			pageIndex: 5,
			title: "Review",
			showInTracker: false,
			pageTitle: `${projectSettings.classActionName} - Review`
		},
		{
			pageIndex: 6,
			title: "Error",
			showInTracker: false,
			pageTitle: `${projectSettings.classActionName} - Error`
		}
	];

	const fileUploadPageList = [
		{
			pageIndex: 0,
			pageTitle: `${projectSettings.classActionName}`,
			title: "Landing Page",
			showInTracker: false,
			nextPage: "FileUpload/Files"
		},
		{
			pageIndex: 1,
			title: "Files",
			showInTracker: true,
			pageTitle: `${projectSettings.classActionName} - Files`,
			nextPage: "FileUpload/ThankYou",
			previousPage: "FileUpload",
			nextPageLabel: "Submit",
			persistUrl: "api/file-upload-submit"
		},
		{
			pageIndex: 2,
			title: "Thank You",
			showInTracker: true,
			pageTitle: `${projectSettings.classActionName} - Thank You`
		},
		{
			pageIndex: 3,
			title: "Error",
			showInTracker: false,
			pageTitle: `${projectSettings.classActionName} - Error`
		}
	];

	const checkLandingUrl = function () {
		if (window.location.pathname.indexOf("/FileUpload") >= 0 && window.location.pathname !== "/FileUpload") {
			window.location.href = "/FileUpload";
			return false;
		} else if (
			window.location.pathname.indexOf("/ConfirmAgreements") >= 0 &&
			window.location.pathname !== "/ConfirmAgreements"
		) {
			window.location.href = "/ConfirmAgreements";
			return false;
		} else if (
			window.location.pathname.indexOf("/Registration") >= 0 &&
			window.location.pathname !== "/Registration"
		) {
			window.location.href = "/Registration";
			return false;
		} else if (
			window.location.pathname.indexOf("/Registration") < 0 &&
			window.location.pathname.indexOf("/ConfirmAgreements") < 0 &&
			window.location.pathname.indexOf("/FileUpload") < 0 &&
			window.location.pathname.indexOf("/Review") < 0
		) {
			window.location.href = "/Registration";
			return false;
		}

		if (window.location.pathname === "/FileUpload") {
			pageList = fileUploadPageList;
		} else {
			pageList = registrationPageList;
		}

		return true;
	};

	if (checkLandingUrl()) {
		window.onbeforeunload = (event) => {
			event.returnValue = `Are you sure you want to leave?`;
		};

		if (window.location.pathname === "/FileUpload" && window.location.search) {
			navigate("/FileUpload", { replace: true });
		} else if (window.location.pathname === "/ConfirmAgreements" && window.location.search) {
			if ($model.AgreementsConfirmed) {
				navigate("/ConfirmAgreements/Thankyou", { replace: true });
			} else {
				navigate("/ConfirmAgreements", { replace: true });
			}
		}
	}
</script>

<Router {url} {basepath}>
	<div>
		<NavTracker {pageList} />

		<Route path="/">
			<RegistrationLandingPage {...pageList[0]}></RegistrationLandingPage>
		</Route>
		<Route path="Registration">
			<RegistrationLandingPage {...pageList[0]}></RegistrationLandingPage>
		</Route>
		<Route path="Registration/PersonalDetails">
			<PersonalDetails {...pageList[1]}></PersonalDetails>
		</Route>
		<Route path="Registration/Details">
			<Details {...pageList[2]}></Details>
		</Route>
		<Route path="Registration/Confirmation">
			<Confirmation {...pageList[3]}></Confirmation>
		</Route>
		<Route path="Registration/ThankYou">
			<ThankYou {...pageList[4]}></ThankYou>
		</Route>

		<Route path="FileUpload">
			<FileUploadLandingPage {...pageList[0]}></FileUploadLandingPage>
		</Route>
		<Route path="FileUpload/Files">
			<Files {...pageList[1]}></Files>
		</Route>
		<Route path="FileUpload/ThankYou">
			<FileUploadThankYou {...pageList[2]}></FileUploadThankYou>
		</Route>

		<Route path="Review" component={Review} />
		<Route path="*/Error" component={Error} />
	</div>
</Router>
